import React, {
  useState,
  useImperativeHandle,
  forwardRef
} from "react";
import { isEmpty } from "lodash-es";
import { useGetRecommendedPostsQuery } from "api";
import NewPostPromptForRecomendedPosts from "./NewPostPromptForRecomendedPosts";
import InfiniteScroll, { Empty } from "components/InfiniteScroll";
import PostComponent from "components/PostComponent";
import ActivityMessage from "components/PostComponent/ActivityMessage";

const RecomendedPosts = forwardRef((_, ref) => {
  const [hasMore, setHasMore] = useState(true);
  const { data, fetchMore, loading, refetch } =
    useGetRecommendedPostsQuery({
      variables: { offset: 0, limit: 20 },
      notifyOnNetworkStatusChange: true,
    });

  useImperativeHandle(
    ref,
    () => {
      return {
        refetch() {
          if (!loading) {
            refetch();
          }
        },
      };
    },
    [loading]
  );

  const fetchMoreData = () => {
    fetchMore({
      variables: { offset: data?.getRecommendedPosts?.length },
    }).then(({ data }) => {
      if (isEmpty(data?.getRecommendedPosts || [])) {
        setHasMore(false);
      }
    });
  };

  return (
    <InfiniteScroll
      dataLength={data?.getRecommendedPosts?.length}
      loading={loading}
      hasMore={hasMore}
      fetchMoreData={fetchMoreData}
      endMessage={<Empty title="No more posts" />}
    >
      <NewPostPromptForRecomendedPosts
        refetch={refetch}
        date={data?.getRecommendedPosts?.[0]?.createdAt}
      />
      {data?.getRecommendedPosts?.map((activity) => (
        <PostComponent
          key={activity?.actId}
          postHeaderComponent={<ActivityMessage activity={activity} />}
          post={activity?.post}
          component_name="home_focused_feed"
        />
      ))}
    </InfiniteScroll>
  );
});

export default RecomendedPosts;
